<label class="form-label" for="name">{{'lang.globals.name' |translate}}</label>
<input id="name" name="name" class="form-control" [(ngModel)]="cullCategory.name">
<div class="my-2">{{'lang.globals.parent'|translate}}</div>
<sb-comp-dropdown-select
  [dropDownDatatype]="'CULL_CATEGORIES'"
  [singleSelectMode]="true" [showSubmit]="false"
  [inputData]="filterCategories"
  (selectedDataEmitter)="update($event, 'CULL_CATEGORIES')" [showColumnIcon]="false"
  [msOptions]="msCategoryOptions" (msOptionsChange)="msRequest('CULL_CATEGORIES', $event)"
  [selectedInputData]="cullCategory.parent ? [cullCategory.parent] : []">
</sb-comp-dropdown-select>
<div class="row mb-3">
  <div class="col-md-12">
    <div class="form-group d-grid">
      <label class="form-label" for="Company">{{'lang.globals.company' | translate}}</label>
      <button [disabled]="companyDisabled" (click)="selectCompany()" type="button" id="Company"
              class="btn btn-secondary  text-center">
        <sb-icon class="mr-1" icon="company"></sb-icon>
        {{cullCategory?.company ? cullCategory?.company?.name : translate.instant('lang.globals.default')}}
      </button>
    </div>
  </div>
</div>


<div class="d-flex justify-content-end mt-4">
  <button [disabled]="!cullCategory.name" (click)=" isInModalContext ? modalNavigationService.result(cullCategory) : saveClick.emit(true)"
          class="btn btn-primary">
    <sb-icon icon="save"></sb-icon>
    {{'lang.globals.save' |translate}}</button>
</div>
